import { EnActionType } from '../enum/en-action-type.enum';

export interface IActionEmitter {
    actionType: EnActionType;
    data?: any;
}
